import Swiper from 'swiper';
import { Mousewheel, Navigation } from 'swiper/modules';

(() => {

  /**
  * Query the existence of the target element. If the element does not
  * exist, stop executing the function.
  */

  let carousels = document.querySelectorAll('.swiper');

  if (!carousels) { return; }

  carousels.forEach(carousel => {
    if (carousel.dataset.carouselType == 'image') {
      const swiper = new Swiper(`#${carousel.id}.swiper`, {
        grabCursor: true,
        modules: [ Mousewheel, Navigation ],
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true
        },
        navigation: {
          nextEl: `[data-swiper-id="${carousel.id}"] .c-carousel__button--next`,
          prevEl: `[data-swiper-id="${carousel.id}"] .c-carousel__button--prev`,
        },
        slidesPerView: 1.2,
        spaceBetween: 30,
        speed: 400,
        breakpoints: {
          768: {
            slidesPerGroup: 2,
            slidesPerView: 2.2,
          },
          1024: {
            slidesPerGroup: 3,
            slidesPerView: 3.2,
          }
        }
      });
    } else {
      const swiper = new Swiper(`#${carousel.id}.swiper`, {
        grabCursor: true,
        modules: [ Mousewheel, Navigation ],
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true
        },
        navigation: {
          nextEl: `[data-swiper-id="${carousel.id}"] .c-carousel__button--next`,
          prevEl: `[data-swiper-id="${carousel.id}"] .c-carousel__button--prev`,
        },
        slidesPerView: 1.2,
        spaceBetween: 30,
        speed: 400,
        breakpoints: {
          768: {
            slidesPerGroup: 2,
            slidesPerView: 2.2,
          }
        }
      });
    }
  });
})()
